import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { dailyHours, weeklyHours, blockedHours } from '__mocks__/mockData/provider-business-hours-data';

const ProvidersBusinessHours = [
  rest.get(`${API_ROOT}provider-weekly-hours`, (req, res, ctx) => {
    const providerId = req.url.searchParams.get('providerId[]');
    if (providerId) {
      return res(ctx.json(weeklyHours));
    }
    return res(ctx.json({}));
  }),
  rest.get(`${API_ROOT}provider-daily-hours`, (req, res, ctx) => {
    const providerId = req.url.searchParams.get('providerId[]');
    if (providerId) {
      return res(ctx.json(dailyHours));
    }
    return res(ctx.json({}));
  }),
  rest.get(`${API_ROOT}provider-blocked-hours`, (req, res, ctx) => {
    const providerIdArray = req.url.searchParams.get('providerId[]');
    const providerId = req.url.searchParams.get('providerId');
    if (providerIdArray) {
      return res(ctx.json(blockedHours));
    }
    if (providerId) {
      return res(ctx.json(blockedHours));
    }
    return res(ctx.json([]));
  }),
  rest.post(`${API_ROOT}provider-blocked-hours`, (req, res, ctx) => res(ctx.json([blockedHours]))),
  rest.get(`${API_ROOT}provider-blocked-hours/${blockedHours[0].id}`, (req, res, ctx) => res(ctx.json(blockedHours[0]))),
  rest.put(`${API_ROOT}provider-blocked-hours/${blockedHours[0].id}`, (req, res, ctx) => res(ctx.json({ success: true }))),
];
export default ProvidersBusinessHours;
